import { RecordVoiceOver } from '@mui/icons-material';
import { Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Component } from 'react';
import MuiUtil from '@/util/MuiUtil';

class IconeAdvogadoSustentacaoOral extends Component {
    static titlePadrao = (<Typography>Pedido de preferência/sustentação</Typography>); // [REVIEW] Separar em dois ícones?
    static corPadrao = 'black';
    static opacidadePadrao = '1';
    removerTooltip = false;
    removerEstiloPadrao = false;

    static get sxPadrao() {
        return {
            color: IconeAdvogadoSustentacaoOral.corPadrao,
            fill: IconeAdvogadoSustentacaoOral.corPadrao,
            fillOpacity: IconeAdvogadoSustentacaoOral.opacidadePadrao
        };
    }

    constructor(props) {
        super(props);

        let { removerEstiloPadrao, removerTooltip, title, ...propsIcone } = this.props;

        // Carrega as propriedades do tooltip
        this.removerTooltip = removerTooltip !== undefined ? removerTooltip : this.removerTooltip;
        this.title = title !== undefined ? title : IconeAdvogadoSustentacaoOral.titlePadrao;

        // Carrega as propriedades do ícone
        this.removerEstiloPadrao = removerEstiloPadrao !== undefined ? removerEstiloPadrao : this.removerEstiloPadrao;

        if (this.removerEstiloPadrao) {
            this.propsIcone = propsIcone;
        } else {
            this.propsIcone = MuiUtil.mesclarSxStyle(propsIcone);
            this.adicionarSxPadrao();
        }
    }

    /**
     * @desc Adiciona as propriedades padrão sem sobrescrever as existentes.
     */
    adicionarSxPadrao() {
        if (!Object.prototype.hasOwnProperty.call(this.propsIcone, 'sx')) {
            this.propsIcone.sx = IconeAdvogadoSustentacaoOral.sxPadrao;
        } else {
            this.propsIcone.sx = { ...IconeAdvogadoSustentacaoOral.sxPadrao, ...this.propsIcone.sx };
        }
    }

    render() {
        if (this.removerTooltip) {
            return <RecordVoiceOver {...this.propsIcone} />;
        } else {
            return (
                <Tooltip title={this.title}>
                    <RecordVoiceOver {...this.propsIcone} />
                </Tooltip>
            );
        }
    }
}

IconeAdvogadoSustentacaoOral.propTypes = {
    removerEstiloPadrao: PropTypes.bool,
    removerTooltip: PropTypes.bool,
    title: PropTypes.node
};

export default IconeAdvogadoSustentacaoOral;
